import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=1a835829&"
import script from "./Overview.vue?vue&type=script&lang=ts&"
export * from "./Overview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports